<template>

  <b-table v-bind="tableAttributes" :fields="fields" :items="items">
    <template #cell(name)="data">
      {{ data.item.name }}
    </template>

    <template #cell(last_name)="data">
      {{ data.item.last_name }}
    </template>

    <template #cell(email)="data">
      <span class="text-wrap">{{ data.item.email }}</span>
    </template>

    <template #cell(role)="data">
      {{ roleFa(data.item.role) }}
    </template>

    <template #cell(created_at)="data">
      {{ convertToJalali(data.item.created_at) }}
    </template>

    <template #cell(action)="data">
      <div v-if="(data.item.deleted_at == null)">
                <span
                    class="h5"
                    v-if="isDeletable(data.item)"
                    @click="deleteFunction(data.item)"
                    v-b-tooltip.hover
                    title="حذف">
                    <b-icon icon="trash" class="m-2"></b-icon>
                </span>

        <span class="h5" v-b-tooltip.hover title="ویرایش">
                    <router-link
                        :to="{ name: 'UpdateUser', params: { id: data.item.id } }">
                        <b-icon icon="pencil" class="m-2"></b-icon>
                    </router-link>
                </span>

        <span class="h5" v-b-tooltip.hover title="تغییر رمز">
                    <router-link
                        :to="{ name: 'UpdateUserPassword', params: { id: data.item.id } }">
                        <b-icon icon="key" class="m-2"></b-icon>
                    </router-link>
                </span>



      </div>

      <div v-else>
                <span
                    class="h5"
                    v-b-tooltip.hover title="حذف دائمی"
                    v-if="isDeletable(data.item)">                                
                    <b-icon icon="trash" @click="forceDeleteFunction(data.item)"></b-icon>
                </span>

        <span class="h5" v-b-tooltip.hover title="بازگردانی">
                    <b-icon
                        icon="arrow-clockwise"
                        class="mr-3"
                        @click="restoreFunction(data.item)">
                    </b-icon>
                </span>
      </div>
    </template>
  </b-table>
</template>

<script>
import {mapActions} from "vuex";
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {convertToJalali} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: 'UserItems',
  props: ['items'],
  data() {
    return {
      tableAttributes: {...tableAttributes, ...{responsive: 'xl'}},
      fields: [
        {key: "name", label: "نام"},
        {key: "last_name", label: "نام خانوادگی"},
        {key: "role", label: "نقش"},
        {key: "email", label: "ایمیل"},
        {key: "cellphone", label: "تلفن همراه"},
        {key: "created_at", label: "تاریخ عضویت"},
        {key: "action", label: "عملیات"},
      ],
    }
  },
  methods: {
    convertToJalali,
    ...mapActions({
      deletePerson: "User/deletePerson",
      forceDeletePerson: "User/forceDeletePerson",
      restorePerson: "User/restorePerson",
    }),
    deleteFunction(item) {
      if (confirm('آیا از حذف این کاربر اطمینان دارید؟')) {
        this.deletePerson(item);
      }
    },
    forceDeleteFunction(item) {
      const message = `
      حذف کاربر باعث حذف موارد ساخته شده توسط کاربر میشود.
      آمار کاربر:
      پست/برگه/درس: ${item.contents_count}
      دوره: ${item.courses_count}
      سفارش ها: ${item.orders_count}
      پیام: ${item.tickets_count}
      `

      if (confirm(message)) {
        this.forceDeletePerson(item);
      }
    },
    restoreFunction(item) {
      if (confirm('آیا از بازیابی این کاربر اطمینان دارید؟')) {
        this.restorePerson(item);
      }
    },
    isDeletable(item) {
      return (item.role == 0);
    },
    roleFa(role) {
      return (role == 0) ? 'کاربر' : 'مدیر';
    },
  }
}
</script>

<style scoped>
.text-wrap {
  word-wrap: break-word;
}
</style>